
import {
  computed, defineComponent, reactive,
} from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import { INotaFiscalItem } from '@/models/Entidades/Fiscal/INotaFiscal';

export default defineComponent({
  name: 'NotaFiscalItemDadosEspecificos',
  props: {
    item: {
      type: Object as () => INotaFiscalItem,
      required: true,
    },
    editavel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Card,
    CampoNumerico,
  },
  emits: ['update:item'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedItem = computed({
      get: () => props.item,
      set: (val: INotaFiscalItem) => {
        emit('update:item', val);
      },
    });

    return {
      props,
      state,
      computedItem,
    };
  },
});
